/**
 * UI-7d Task 5 — SoxEvidenceCell.
 *
 * Cell renderer for the SOX control log's `evidence` column. Evidence
 * is unstructured JSON (per-control payload — DEK rotation diff, RLS
 * probe results, etc), so we render it as a collapsible <details>
 * containing pretty-printed JSON. Null / undefined evidence collapses
 * to a muted em-dash so dense list rows stay readable.
 */
import type { JSX } from 'react'

export interface SoxEvidenceCellProps {
  evidence: unknown
}

export function SoxEvidenceCell({
  evidence,
}: SoxEvidenceCellProps): JSX.Element {
  if (evidence === null || evidence === undefined) {
    return <span className="text-gray-400">—</span>
  }
  return (
    <details className="cursor-pointer">
      <summary className="text-xs text-blue-600">View evidence</summary>
      <pre className="text-xs bg-gray-50 p-2 rounded-sm mt-1 max-w-md overflow-auto">
        {JSON.stringify(evidence, null, 2)}
      </pre>
    </details>
  )
}

export default SoxEvidenceCell
